<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Ajout utilisateur</h4>
      <div class="text-right">
        <p-button @click="goBack" type="button" class="btn btn-sm btn-primary"
          >Retour</p-button
        >
      </div>
    </div>
    <div class="card-body">
      <form @submit.prevent>
        <div class="form-group">
          <label class="form-control-label"> Photo du profil  </label>
          <div
            v-if="image"
            class="profile-image card-img pb-4"
            :style="{
              'background-image': `url('${image}')`,
            }"
          ></div>
          <div v-else class="profile-image">
            <img src="/img/placeholder.jpg" />
          </div>
          <div class="image-upload">
            <button
              v-if="image"
              type="button"
              class="btn btn-fill btn-wd btn-danger"
              @click="removeImage"
            >
              <span>
                <i class="fa fa-times" />
                Supprimer
              </span>
            </button>
            <input
              id="imageInput"
              ref="imageInput"
              accept="image/*"
              type="file"
              style="display: none"
              @change="onSelectFile"
            />

            <button
              type="button"
              class="btn btn-info btn-fill btn-wd"
              @click="onClickFile"
            >
              <label v-if="!image" class="mb-0">Sélectionner une image</label>
              <label v-else class="mb-0">Changer</label>
            </button>
          </div>
        </div>
        <validation-error :errors="apiValidationErrors.attachment" />
        <fg-input
          v-model="user.name"
          placeholder="Prénom Nom"
          label="Nom"
        ></fg-input>
        <validation-error :errors="apiValidationErrors.name" />
        <br>
        <el-select class="select-info"
                   placeholder="Société"
                   v-model="user.societe_id">
          <el-option v-for="societe in liste_societes"
                     class="select-danger"
                     :value="societe.id"
                     :label="societe.nom.toUpperCase()"
                     :key="societe.id">
          </el-option>
        </el-select>       &nbsp;
        <el-select class="select-info"
                   placeholder="Secteur"
                   v-model="user.secteur_id">
          <el-option v-for="secteur in liste_secteurs"
                     class="select-danger"
                     :value="secteur.id"
                     :label="secteur.nom.toUpperCase()"
                     :key="secteur.id">
          </el-option>
        </el-select>       &nbsp;
        <el-select class="select-info"
                   placeholder="Poste"
                   v-model="user.poste_id">
          <el-option v-for="poste in liste_postes"
                     class="select-danger"
                     :value="poste.id"
                     :label="poste.nom.toUpperCase()"
                     :key="poste.id">
          </el-option>
        </el-select>

        <fg-input
                v-model="user.surnom"
                placeholder="Surnom"
                label="Surnom"
        ></fg-input>
        <validation-error :errors="apiValidationErrors.surnom" />
        <fg-input
                v-model="user.username"
                placeholder="Première lettre du prénom.nom"
                label="Nom d'utilisateur"
        ></fg-input>
        <validation-error :errors="apiValidationErrors.username" />
        <fg-input
          v-model="user.email"
          placeholder="Adresse email"
          label="Adresse email"
        ></fg-input>
        <validation-error :errors="apiValidationErrors.email" />
        <fg-input
                v-model="user.no_int"
                placeholder="Numéro interne"
                label="Numéro interne"
        ></fg-input>
        <validation-error :errors="apiValidationErrors.no_int" />
        <fg-input
                v-model="user.no_ext"
                placeholder="Numéro externe"
                label="Numéro externe"
        ></fg-input>
        <validation-error :errors="apiValidationErrors.no_ext" />
        <fg-input
                v-model="user.mobile"
                placeholder="Numéro mobile"
                label="Numéro mobile"
        ></fg-input>
        <validation-error :errors="apiValidationErrors.mobile" />

        <fg-input label="Droits utilisateur">
          <el-select
            class="select-default"
            placeholder="Droits utilisateur"
            v-model="user.roles[0].id"
          >
            <el-option
              class="select-default"
              v-for="role in available_roles"
              :key="role.id"
              :label="role.name"
              :value="role.id"
            >
            </el-option>
          </el-select>
        </fg-input>
        <validation-error :errors="apiValidationErrors.roles" />
        <fg-input
          v-model="user.password"
          placeholder="Mot de passe"
          label="Mot de passe"
          type="password"
        ></fg-input>
        <validation-error :errors="apiValidationErrors.password" />
        <fg-input
          v-model="user.password_confirmation"
          placeholder="Confirmation du mot de passe"
          label="Confirmation du mot de passe"
          type="password"
        ></fg-input>
        <validation-error :errors="apiValidationErrors.password_confirmation" />
        <div class="text-center">
          <button
            native-type="submit"
            class="btn btn-info btn-fill btn-wd"
            @click="add()"
          >
            Enregistrer
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
export default {
  mixins: [formMixin],
  components: {
    ValidationError,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data: () => ({
    user: {
      type: "users",
      name: null,
      email: null,
      password: null,
      password_confirmation: null,
      profile_image: '/images/default.png',
      roles: [
        {
          id: null,
          type: "roles",
        },
      ],
      relationshipNames: ["roles"],
    },
    image: null,
    file: null,
    available_roles: [],
    liste_societes:[
      {
        "id": 1,
        "nom": "CDA",
        "created_at": "2022-03-24 10:30:46",
        "updated_at": "2022-03-24 10:30:46"
      },
      {
        "id": 2,
        "nom": "CDU",
        "created_at": "2022-03-24 10:30:47",
        "updated_at": "2022-03-24 10:30:47"
      },
      {
        "id": 3,
        "nom": "CDA USA",
        "created_at": "2022-03-24 10:30:49",
        "updated_at": "2022-03-24 10:30:49"
      },
      {
        "id": 4,
        "nom": "CDA DE",
        "created_at": "2022-03-24 10:30:52",
        "updated_at": "2022-03-24 10:30:52"
      }
    ],
    liste_secteurs :[
      {
        "id": 19,
        "nom": "ACCUEIL",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:59",
        "updated_at": "2022-03-07 09:44:59"
      },
      {
        "id": 20,
        "nom": "ADMINISTRATIF",
        "societe_id": 1,
        "created_at": "2022-07-05 08:58:34",
        "updated_at": "2022-07-05 08:58:34"
      },
      {
        "id": 9,
        "nom": "ASSISTANTE COMMERCIALE",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:48",
        "updated_at": "2022-03-07 09:44:48"
      },
      {
        "id": 11,
        "nom": "ATELIER",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:49",
        "updated_at": "2022-03-07 09:44:49"
      },
      {
        "id": 21,
        "nom": "AUTOMATISME",
        "societe_id": 1,
        "created_at": "2022-07-05 08:58:34",
        "updated_at": "2022-07-05 08:58:34"
      },
      {
        "id": 12,
        "nom": "BUREAU D'ETUDE",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:49",
        "updated_at": "2022-03-07 09:44:49"
      },
      {
        "id": 3,
        "nom": "COMMERCIAUX",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:47",
        "updated_at": "2022-03-07 09:44:47"
      },
      {
        "id": 10,
        "nom": "COMPTABILITE",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:49",
        "updated_at": "2022-03-07 09:44:49"
      },
      {
        "id": 7,
        "nom": "EXPEDITION",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:48",
        "updated_at": "2022-03-07 09:44:48"
      },
      {
        "id": 16,
        "nom": "MARKETING / INFORMATIQUE",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:52",
        "updated_at": "2022-03-07 09:44:52"
      },
      {
        "id": 2,
        "nom": "MOBILES COMMERCIAUX",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:47",
        "updated_at": "2022-03-07 09:44:47"
      },
      {
        "id": 15,
        "nom": "MOBILES FILIALES",
        "societe_id": 3,
        "created_at": "2022-03-07 09:44:51",
        "updated_at": "2022-03-07 09:44:51"
      },
      {
        "id": 18,
        "nom": "MOBILES PDG",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:57",
        "updated_at": "2022-03-07 09:44:57"
      },
      {
        "id": 5,
        "nom": "MOBILES PROD / SAV / BE",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:48",
        "updated_at": "2022-03-07 09:44:48"
      },
      {
        "id": 1,
        "nom": "MOBILES SAV",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:46",
        "updated_at": "2022-03-07 09:44:46"
      },
      {
        "id": 8,
        "nom": "PRESSE",
        "societe_id": 2,
        "created_at": "2022-03-07 09:44:48",
        "updated_at": "2022-03-07 09:44:48"
      },
      {
        "id": 13,
        "nom": "R&D",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:49",
        "updated_at": "2022-03-07 09:44:49"
      },
      {
        "id": 17,
        "nom": "RH",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:56",
        "updated_at": "2022-03-07 09:44:56"
      },
      {
        "id": 4,
        "nom": "SAV",
        "societe_id": 1,
        "created_at": "2022-03-07 09:44:47",
        "updated_at": "2022-03-07 09:44:47"
      },
      {
        "id": 6,
        "nom": "STANDARD",
        "societe_id": 2,
        "created_at": "2022-03-07 09:44:48",
        "updated_at": "2022-03-07 09:44:48"
      }
    ] ,
    liste_postes : [
      {
        "id": 45,
        "nom": "ACHAT",
        "secteur_id": 11,
        "created_at": "2022-03-07 09:44:59",
        "updated_at": "2022-03-07 09:44:59"
      },
      {
        "id": 8,
        "nom": "ASSISTANTE CO",
        "secteur_id": 9,
        "created_at": "2022-03-07 09:44:48",
        "updated_at": "2022-03-07 09:44:48"
      },
      {
        "id": 30,
        "nom": "ASSISTANTE CO EXPORT",
        "secteur_id": 9,
        "created_at": "2022-03-07 09:44:55",
        "updated_at": "2022-03-07 09:44:55"
      },
      {
        "id": 42,
        "nom": "AUTOMATICIEN",
        "secteur_id": 13,
        "created_at": "2022-03-07 09:44:58",
        "updated_at": "2022-03-07 09:44:58"
      },
      {
        "id": 21,
        "nom": "BOL / TRI",
        "secteur_id": 11,
        "created_at": "2022-03-07 09:44:52",
        "updated_at": "2022-03-07 09:44:52"
      },
      {
        "id": 28,
        "nom": "CDA DEUTSCHLAND",
        "secteur_id": 3,
        "created_at": "2022-03-07 09:44:55",
        "updated_at": "2022-03-07 09:44:55"
      },
      {
        "id": 49,
        "nom": "CDU",
        "secteur_id": 14,
        "created_at": "2022-07-05 08:58:34",
        "updated_at": "2022-07-05 08:58:34"
      },
      {
        "id": 50,
        "nom": "CHARGEE DE MISSION",
        "secteur_id": 20,
        "created_at": "2022-07-05 08:58:34",
        "updated_at": "2022-07-05 08:58:34"
      },
      {
        "id": 19,
        "nom": "CHARGé DE COM",
        "secteur_id": 16,
        "created_at": "2022-03-07 09:44:52",
        "updated_at": "2022-03-07 09:44:52"
      },
      {
        "id": 11,
        "nom": "CHARGéE DE CLIENTèLE",
        "secteur_id": 12,
        "created_at": "2022-03-07 09:44:49",
        "updated_at": "2022-03-07 09:44:49"
      },
      {
        "id": 26,
        "nom": "CHEF éQUIPE NINETTE",
        "secteur_id": 11,
        "created_at": "2022-03-07 09:44:54",
        "updated_at": "2022-03-07 09:44:54"
      },
      {
        "id": 29,
        "nom": "CO SUD",
        "secteur_id": 3,
        "created_at": "2022-03-07 09:44:55",
        "updated_at": "2022-03-07 09:44:55"
      },
      {
        "id": 36,
        "nom": "COLIS",
        "secteur_id": 4,
        "created_at": "2022-03-07 09:44:56",
        "updated_at": "2022-03-07 09:44:56"
      },
      {
        "id": 24,
        "nom": "COMPTA",
        "secteur_id": 10,
        "created_at": "2022-03-07 09:44:53",
        "updated_at": "2022-03-07 09:44:53"
      },
      {
        "id": 12,
        "nom": "CONCEPTEUR",
        "secteur_id": 13,
        "created_at": "2022-03-07 09:44:49",
        "updated_at": "2022-03-07 09:44:49"
      },
      {
        "id": 9,
        "nom": "DAF",
        "secteur_id": 10,
        "created_at": "2022-03-07 09:44:49",
        "updated_at": "2022-03-07 09:44:49"
      },
      {
        "id": 4,
        "nom": "DIRECTEUR CO",
        "secteur_id": 3,
        "created_at": "2022-03-07 09:44:48",
        "updated_at": "2022-03-07 09:44:48"
      },
      {
        "id": 10,
        "nom": "DIRECTEUR PRODUCTION",
        "secteur_id": 11,
        "created_at": "2022-03-07 09:44:49",
        "updated_at": "2022-03-07 09:44:49"
      },
      {
        "id": 34,
        "nom": "DRH",
        "secteur_id": 17,
        "created_at": "2022-03-07 09:44:56",
        "updated_at": "2022-03-07 09:44:56"
      },
      {
        "id": 13,
        "nom": "ELECTRICIENS",
        "secteur_id": 11,
        "created_at": "2022-03-07 09:44:50",
        "updated_at": "2022-03-07 09:44:50"
      },
      {
        "id": 43,
        "nom": "ETIQUETAGE",
        "secteur_id": 12,
        "created_at": "2022-03-07 09:44:59",
        "updated_at": "2022-03-07 09:44:59"
      },
      {
        "id": 27,
        "nom": "EXPORT (AFRIQUE)",
        "secteur_id": 3,
        "created_at": "2022-03-07 09:44:54",
        "updated_at": "2022-03-07 09:44:54"
      },
      {
        "id": 2,
        "nom": "EXPORT (EUROPE)",
        "secteur_id": 3,
        "created_at": "2022-03-07 09:44:47",
        "updated_at": "2022-03-07 09:44:47"
      },
      {
        "id": 6,
        "nom": "EXPéDITION MACHINES",
        "secteur_id": 7,
        "created_at": "2022-03-07 09:44:48",
        "updated_at": "2022-03-07 09:44:48"
      },
      {
        "id": 31,
        "nom": "FILIALE",
        "secteur_id": 12,
        "created_at": "2022-03-07 09:44:55",
        "updated_at": "2022-03-07 09:44:55"
      },
      {
        "id": 3,
        "nom": "GESTIONNAIRE SERVICE CLIENTS",
        "secteur_id": 4,
        "created_at": "2022-03-07 09:44:47",
        "updated_at": "2022-03-07 09:44:47"
      },
      {
        "id": 23,
        "nom": "GRAPHISTE",
        "secteur_id": 16,
        "created_at": "2022-03-07 09:44:53",
        "updated_at": "2022-03-07 09:44:53"
      },
      {
        "id": 41,
        "nom": "INDUS",
        "secteur_id": 11,
        "created_at": "2022-03-07 09:44:58",
        "updated_at": "2022-03-07 09:44:58"
      },
      {
        "id": 37,
        "nom": "INFORMATICIEN",
        "secteur_id": 16,
        "created_at": "2022-03-07 09:44:57",
        "updated_at": "2022-03-07 09:44:57"
      },
      {
        "id": 47,
        "nom": "MAGASINS",
        "secteur_id": 11,
        "created_at": "2022-03-07 09:45:00",
        "updated_at": "2022-03-07 09:45:00"
      },
      {
        "id": 18,
        "nom": "MONOBLOC",
        "secteur_id": 12,
        "created_at": "2022-03-07 09:44:51",
        "updated_at": "2022-03-07 09:44:51"
      },
      {
        "id": 7,
        "nom": "PRESSE",
        "secteur_id": 8,
        "created_at": "2022-03-07 09:44:48",
        "updated_at": "2022-03-07 09:44:48"
      },
      {
        "id": 46,
        "nom": "PROCESS",
        "secteur_id": 13,
        "created_at": "2022-03-07 09:45:00",
        "updated_at": "2022-03-07 09:45:00"
      },
      {
        "id": 40,
        "nom": "PRéMONTAGE",
        "secteur_id": 11,
        "created_at": "2022-03-07 09:44:58",
        "updated_at": "2022-03-07 09:44:58"
      },
      {
        "id": 20,
        "nom": "QUALITé / CONCEPTEUR",
        "secteur_id": 13,
        "created_at": "2022-03-07 09:44:52",
        "updated_at": "2022-03-07 09:44:52"
      },
      {
        "id": 25,
        "nom": "REMPLISSAGE",
        "secteur_id": 12,
        "created_at": "2022-03-07 09:44:53",
        "updated_at": "2022-03-07 09:44:53"
      },
      {
        "id": 16,
        "nom": "RESP BE ETIQUETAGE",
        "secteur_id": 12,
        "created_at": "2022-03-07 09:44:51",
        "updated_at": "2022-03-07 09:44:51"
      },
      {
        "id": 35,
        "nom": "RESP BE REMPLISSAGE",
        "secteur_id": 12,
        "created_at": "2022-03-07 09:44:56",
        "updated_at": "2022-03-07 09:44:56"
      },
      {
        "id": 17,
        "nom": "RESP CDU",
        "secteur_id": 14,
        "created_at": "2022-03-07 09:44:51",
        "updated_at": "2022-03-07 09:44:51"
      },
      {
        "id": 39,
        "nom": "RESP HOTLINE",
        "secteur_id": 4,
        "created_at": "2022-03-07 09:44:58",
        "updated_at": "2022-03-07 09:44:58"
      },
      {
        "id": 44,
        "nom": "RESP R&D",
        "secteur_id": 13,
        "created_at": "2022-03-07 09:44:59",
        "updated_at": "2022-03-07 09:44:59"
      },
      {
        "id": 22,
        "nom": "RESP SAV",
        "secteur_id": 4,
        "created_at": "2022-03-07 09:44:53",
        "updated_at": "2022-03-07 09:44:53"
      },
      {
        "id": 38,
        "nom": "RESPONSABLE MARKET",
        "secteur_id": 16,
        "created_at": "2022-03-07 09:44:57",
        "updated_at": "2022-03-07 09:44:57"
      },
      {
        "id": 14,
        "nom": "RESSOURCE TECHNIQUE",
        "secteur_id": 13,
        "created_at": "2022-03-07 09:44:50",
        "updated_at": "2022-03-07 09:44:50"
      },
      {
        "id": 33,
        "nom": "SAV",
        "secteur_id": 4,
        "created_at": "2022-03-07 09:44:55",
        "updated_at": "2022-03-07 09:44:55"
      },
      {
        "id": 5,
        "nom": "STANDARD",
        "secteur_id": 6,
        "created_at": "2022-03-07 09:44:48",
        "updated_at": "2022-03-07 09:44:48"
      },
      {
        "id": 15,
        "nom": "STOCK CDU",
        "secteur_id": 14,
        "created_at": "2022-03-07 09:44:50",
        "updated_at": "2022-03-07 09:44:50"
      },
      {
        "id": 48,
        "nom": "TECHNICIEN",
        "secteur_id": 4,
        "created_at": "2022-07-05 08:58:34",
        "updated_at": "2022-07-05 08:58:34"
      },
      {
        "id": 32,
        "nom": "WEB DEVELOPPEUR",
        "secteur_id": 16,
        "created_at": "2022-03-07 09:44:55",
        "updated_at": "2022-03-07 09:44:55"
      }
    ]
  }),

  created() {
    this.getRoles();
  },

  methods: {
    onClickFile() {
      this.$refs.imageInput.click();
    },
    async onSelectFile(e) {
      const input = this.$refs.imageInput;
      const files = input.files;

      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        reader.readAsDataURL(files[0]);
      }
    },

    removeImage() {
      this.image = null;
      this.$refs.imageInput.value = "";
    },
    async add() {


      try {
        this.resetApiValidation();
        delete this.user.id;

        await this.$store.dispatch("users/add", this.user);

        this.user = await this.$store.getters["users/user"];

        if (this.image) {
          await this.$store.dispatch("users/upload", {
            user: this.user,
            image: this.$refs.imageInput.files[0],
          });
          this.user.profile_image = await this.$store.getters["users/url"];
          // update user with image url
          await this.$store.dispatch("users/update", this.user);
          this.user = await this.$store.getters["users/user"];
        }
        this.$notify({
          type: "success",
          message: "Utilisateur ajouté avec succès.",
          icon: "nc-icon nc-bell-55",
        });
        this.goBack();
      } catch (e) {
        this.$notify({
          type: "danger",
          message: "Oups, quelque chose s'est mal passé !",
          icon: "nc-icon nc-bell-55",
        });
        this.setApiValidation(e.response.data.errors);
        if(this.user.username == null || this.user.username == ''){
          this.apiValidationErrors.username = ['Le nom d\'utilisateur est obligatoire.'];
        }
        if (this.user.id) {
          await this.$store.dispatch("users/destroy", this.user.id);
        }
      }
    },

    getRoles() {
      this.$store.dispatch("roles/list").then(() => {
        this.available_roles = this.$store.getters["roles/dropdown"];
        this.available_roles.shift();
        this.available_roles[0].name = 'membre'
      });
    },

    goBack() {
      this.$router.push({ name: "List Users" });
    },
  },
};
</script>
<style>
</style>
